export let PerformanceSecondApprovalRoutes = {
    "/performance-second-approval": {
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['centralized-settings']
        },
        "component": "performanceSecondApprovalComponent",
        "type": "frontend",
        "name": "appLayout.harriSH.performance-second-approval",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/performance-second-approval/performance-second-approval.module.js");
                }
            },

        ],
        "showGlobalSearch": true,
        "loginRequired": true
    },
};
